export interface IClient {
  canAddNewClient: boolean;
  canModifyExistingClient: boolean;
  canChangeDefaultCountryAndProvince: boolean;
  canAddNewAddress: boolean;
  canModifyAddress: boolean;
}
export interface ITransactions {
  sales: boolean;
  returns: boolean;
  exchange: boolean;
  canUseExternalTypes: boolean;
  canPayToClient: boolean;
  canReciveFromClient: boolean;
  canPayToCenteralBox: boolean;
  canReciveFromCenteralBox: boolean;
  canDeleteExternalTransacation: boolean;
  isHavingMaxValueForTransaction: boolean;
  maxAllowedValueTransaction: number;
}

export interface ITransactionPermissions {
  changePrice: boolean;
  sellInDebt: boolean;
  deleteAnItem: boolean;
  reduceQuantity: boolean;
  viewSettledTransactions: boolean;
  reprintSettledTransaction: boolean;
  openDrawerManualy: boolean;
  makeDiscountOnItem: boolean;
  itemDisCountPercentage: number;
  makeDiscountOnTransaction: boolean;
  transactionDisCountPercentage: number;
  canUseFc: boolean;
  canModifyExChangeRates: boolean;
  printCustomizationBeforeCollect: boolean;
  sendEReceipt: boolean;
}

export interface IShift {
  closeShift: boolean;
  viewCalculatedCash: boolean;
  postCashToNextShift: boolean;
  unCloseShift: boolean;
  centralBoxReceiptNumberMandatory: boolean;
  printShiftSummary: boolean;
}
export interface IOrder {
  addPickUpOrder: boolean;
  addDeliveryOrder: boolean;
  editDeliveryFees: boolean;
  receivePrepayment: boolean;
  cancelOrder: boolean;
  editSavedOrder: boolean;
  useOrderManagementTab: boolean;
  canViewDeliveryOrdersTab: boolean;
  canViewPickupOrdersTab: boolean;
  canViewTableOrdersTab: boolean;
  useDeliveryOrdersManagement: boolean;
  settlePickupOrder: boolean;
  settleDeliveryTrip: boolean;
  settleTableOrder: boolean;
  moveOrder: boolean;
  moveOrderItems: boolean;
  canHandleTableOrder: boolean;
}
export interface IPreaparingAndServing {
  canCancelOrderAfterPreparationStarts: boolean;
  canCancelOrderAfterServed: boolean;
  canCancelItemAfterPreparationStarts: boolean;
  canCancelItemAfterServed: boolean;
  canChangeItemQuantityAfterPreparationStarts: boolean;
  canChangeItemQuantityAfterServed: boolean;
  canReturnOrderFromInPreparation: boolean;
  canEndPreparationInKitchenWindow: boolean;
}
export interface IReportsOptions {
  customerBalanceStatement: boolean;
  showCustomerBalance: boolean;
  calculatedCashDetails: boolean;
  calculatedNonCashDetails: boolean;
  shiftDigest: boolean;
  materialsAndServicesTransactionsDetail: boolean;
  externalTransactionsDetails: boolean;
  closingDetails: boolean;
}

export interface IMenusOptions {
  canChangeMenu: boolean;
  canChangeMenuWhenOpenOrder: boolean;
}

export interface IPosUser {
  posId: string;
  posName: string;
  storeId: string;
  storeName: string;
}

export default interface IEmployeeData {
  id?: string;
  name: string;
  employeeCode: string;
  image: string;
  isSupervisor: boolean;
  isActive: boolean;
  email: string;
  password: string;
  phone?: string;
  preferedLanguage: string;
  updatedOn?: string;
  posUsers: IPosUser[];
  clientOptions: IClient;
  transactionsOptions: ITransactions;
  transactionPermissionsOptions: ITransactionPermissions;
  shiftOptions: IShift;
  orderOptions: IOrder;
  preparingAndServing: IPreaparingAndServing;
  reportsOptions: IReportsOptions;
  menusOptions: IMenusOptions;
  pinCode: string;
  currentShift: boolean;
}

export const EmptyEmployee: IEmployeeData = {
  id: undefined,
  name: "",
  employeeCode: "",
  image: "",
  isSupervisor: false,
  isActive: true,
  email: "",
  password: "",
  phone: "",
  updatedOn: undefined,
  preferedLanguage: "",
  posUsers: [],
  currentShift: false,
  clientOptions: {
    canAddNewClient: false,
    canModifyExistingClient: false,
    canChangeDefaultCountryAndProvince: false,
    canAddNewAddress: false,
    canModifyAddress: false,
  },

  transactionsOptions: {
    sales: true,
    returns: false,
    exchange: false,
    canUseExternalTypes: false,
    canPayToClient: false,
    canReciveFromClient: false,
    canPayToCenteralBox: false,
    canReciveFromCenteralBox: false,
    canDeleteExternalTransacation: false,
    isHavingMaxValueForTransaction: false,
    maxAllowedValueTransaction: 0,
  },

  transactionPermissionsOptions: {
    changePrice: false,
    sellInDebt: false,
    deleteAnItem: false,
    reduceQuantity: false,
    viewSettledTransactions: false,
    reprintSettledTransaction: false,
    openDrawerManualy: false,
    makeDiscountOnItem: false,
    itemDisCountPercentage: 0,
    makeDiscountOnTransaction: false,
    transactionDisCountPercentage: 0,
    canUseFc: false,
    canModifyExChangeRates: false,
    printCustomizationBeforeCollect: false,
    sendEReceipt: false,
  },
  shiftOptions: {
    closeShift: false,
    viewCalculatedCash: false,
    postCashToNextShift: false,
    unCloseShift: false,
    centralBoxReceiptNumberMandatory: false,
    printShiftSummary: false
  },
  orderOptions: {
    addPickUpOrder: false,
    addDeliveryOrder: false,
    editDeliveryFees: false,
    receivePrepayment: false,
    cancelOrder: false,
    editSavedOrder: false,
    useOrderManagementTab: false,
    canViewDeliveryOrdersTab: false,
    canViewPickupOrdersTab: false,
    canViewTableOrdersTab: false,
    useDeliveryOrdersManagement: false,
    settlePickupOrder: false,
    settleDeliveryTrip: false,
    settleTableOrder: false,
    moveOrder: false,
    moveOrderItems: false,
    canHandleTableOrder: false,
  },
  preparingAndServing: {
    canCancelOrderAfterPreparationStarts: false,
    canCancelOrderAfterServed: false,
    canCancelItemAfterPreparationStarts: false,
    canCancelItemAfterServed: false,
    canChangeItemQuantityAfterPreparationStarts: false,
    canChangeItemQuantityAfterServed: false,
    canReturnOrderFromInPreparation: false,
    canEndPreparationInKitchenWindow: false,
  },
  reportsOptions: {
    customerBalanceStatement: false,
    showCustomerBalance: false,
    calculatedCashDetails: false,
    calculatedNonCashDetails: false,
    shiftDigest: false,
    materialsAndServicesTransactionsDetail: false,
    externalTransactionsDetails: false,
    closingDetails: false,
  },
  menusOptions: {
    canChangeMenu: false,
    canChangeMenuWhenOpenOrder: false,
  },
  pinCode: "",
};
